import {useState} from "react";
import styled from "styled-components";
import {SelectFilter} from "ui/base/selectInput/SelectFilter";
import {fonts, mediaSizes, themeColor, themeFontSize} from "ui/theme";
import ShadowImg from "static/pictures/shadow-img.png";
import {scrollbarStyles} from "ui/base/scrollbarStyle/scrollbarStyle";
import {ClassCard} from "ui/base/class/ClassCard";
import {useNavigate} from "react-router-dom";
import {userRoute} from "../../user.routes";

export const List = ({typeOfClass, classes}) => {
    const navigate = useNavigate();
    const [showShadow, setShowShadow] = useState(true);
    const scrollHandler = () => {
        if (showShadow) setShowShadow(false);
    };
    return (
        <Container>
            <Title>{typeOfClass} </Title>
            <ListHeader>
                <ListHeaderText>{classes?.length ?? 0} results</ListHeaderText>
                <div>
                    <SelectFilter
                        showIndicator
                        controlledMenu={false}
                        placeholder="Default sorting"
                        bgColor="transparent"
                    />
                </div>
            </ListHeader>
            <ListClassContainer onScroll={() => scrollHandler()}>
                {classes?.map((item) => (
                    <ClassCard
                        key={item.id}
                        classData={item}
                        onClick={() => navigate(userRoute.classDetail + +item.user_id)}
                    />
                ))}
                {classes.length > 3 && showShadow && <Shadow src={ShadowImg}/>}
            </ListClassContainer>
        </Container>
    );
};
const Container = styled.div`
    padding-block: 1rem;
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex-grow: 1;
    min-height: 0;
    font-family: Montserrat;
    order: 2;
    @media (width >= ${mediaSizes.lg}) {
        order: 1;
    }
`;

const Shadow = styled.img`
    position: absolute;
    bottom: 0;
    max-width: 888px;
`;

const Title = styled.h2`
    font-size: ${fonts.sizes.big};
    font-weight: 600;
    display: none;

    @media (width >= ${mediaSizes.lg}) {
        font-size: ${fonts.sizes["h3.4"]};
        display: block;
    }
`;

const ListHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: fit-content;
`;

const ListHeaderText = styled.p`
    color: ${themeColor("txt")};
    font-size: ${themeFontSize("regular")};
    font-weight: 400;
    line-height: 155%;
    letter-spacing: 0;
`;

const ListClassContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    overflow-y: auto;
    gap: 1rem;
    justify-content: center;
    padding: 1rem;

    @media (width >= ${mediaSizes.md}) {
        grid-template-columns: repeat(auto-fit, minmax(220px, 0.5fr));
        justify-content: start;
    }
    @media (width >= ${mediaSizes.lg}) {
        grid-template-columns: repeat(auto-fit, minmax(220px, 0.5fr));
        justify-content: start;
        height: 69dvh;
    }

    ${scrollbarStyles}
`;
